var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 83,
    viewBox: "0 0 72 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1471"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1459"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xC3\xA1ngulo 541",
    x: 29.6731,
    y: 18.3991,
    width: 9.76191,
    height: 3.3217,
    fill: "#3DBFCD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2449",
    d: "M38.3041 17.0682H30.8033C30.6836 17.9902 30.2211 20.6878 29.4202 21.4301C29.4796 30.2301 39.8023 30.1921 39.6869 21.4301C38.8863 20.6878 38.4239 17.9902 38.3041 17.0682Z",
    fill: "#F39C56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2450",
    d: "M34.554 1.63805L27.8962 6.13997L29.2117 16.3878C29.2117 16.3878 31.4326 19.7878 34.554 19.7878C37.6753 19.7878 39.8961 16.3878 39.8961 16.3878L41.2116 6.13997L34.554 1.63805Z",
    fill: "#FAB67A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2451",
    d: "M37.6419 21.809L34.5539 21.423L31.4658 21.809L28.1199 24.831C29.2798 28.7213 32.8006 33.2372 34.5539 35.0665C36.3071 33.2372 39.8281 28.7213 40.988 24.831L37.6419 21.809Z",
    fill: "#3DBFCD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1452"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2452",
    d: "M28.6847 10.2518C27.4634 9.10483 26.568 10.5089 27.9955 12.9128C27.9955 12.9128 27.887 13.704 28.9094 13.704L28.6847 10.2518Z",
    fill: "#FAB67A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2453",
    d: "M40.4235 10.2519C41.6445 9.10489 42.5399 10.509 41.1125 12.9129C41.1125 12.9129 41.2211 13.7041 40.1987 13.7041L40.4235 10.2519Z",
    fill: "#FAB67A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1453"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2454",
    d: "M28.3942 10.7637C28.3942 10.7637 28.1002 10.6198 27.8595 10.7637C27.8595 10.7637 27.5701 10.9077 27.7586 11.3391L28.166 12.562C28.166 12.562 28.4404 12.4381 28.6513 12.562C28.7713 11.7747 27.4003 11.0513 28.3942 10.7637Z",
    fill: "#F39C56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2455",
    d: "M40.7142 10.7638C40.7142 10.7638 41.0078 10.6199 41.2481 10.7638C41.2481 10.7638 41.5381 10.9078 41.3495 11.3392L40.9418 12.562C40.9418 12.562 40.6678 12.4381 40.4567 12.562C40.3369 11.7748 41.7081 11.0514 40.7142 10.7638Z",
    fill: "#F39C56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1454"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2456",
    d: "M35.6862 25.1321H33.2778L32.2666 35.9451L33.5155 38.3752L34.4833 38.6756L35.4496 38.3752L36.6976 35.9451L35.6862 25.1321Z",
    fill: "#DF3826"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2457",
    d: "M36.066 21.4227H32.8993L31.9939 22.8125L33.278 25.1323H35.6863L36.9704 22.8125L36.066 21.4227Z",
    fill: "#DF3826"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2458",
    d: "M28.2281 9.93078L28.9088 12.2657H29.6685L29.0651 6.40568C30.0917 4.62371 31.9159 4.67693 34.5536 4.9773C37.1915 4.67693 39.0152 4.62371 40.042 6.40568L39.4385 12.2657H40.1982L40.879 9.93078C45.8721 -3.17857 23.2354 -3.17763 28.2281 9.93078Z",
    fill: "#313C3B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1456"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1455"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2459",
    d: "M26.7921 20.1868C26.7921 20.1868 20.0523 22.2278 18.7642 26.3666L18.3652 40.3114H24.177L25.0874 31.1375L25.347 40.3114H34.5536V35.067L32.3791 32.0227L31.4272 29.0735L26.7921 20.1868Z",
    fill: "#3C3F98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2460",
    d: "M42.3151 20.1867C42.3151 20.1867 49.055 22.2277 50.343 26.3665L50.7422 40.3114H44.9303L44.0199 31.1375L43.7605 40.3114H34.5537V35.0669L36.1464 32.8929L37.4586 29.4976L42.3151 20.1867Z",
    fill: "#3C3F98"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2461",
    d: "M36.6065 36.227C36.6065 36.5052 36.4005 36.7309 36.1465 36.7309C35.8925 36.7309 35.6865 36.5052 35.6865 36.227C35.6865 35.9486 35.8925 35.7231 36.1465 35.7231C36.4005 35.7231 36.6065 35.9486 36.6065 36.227Z",
    fill: "#2B286B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1457"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2462",
    d: "M39.4351 18.3992L34.5542 21.4229L37.7177 25.2188L41.4028 20.8182L39.4351 18.3992Z",
    fill: "#87D2DC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2463",
    d: "M29.6733 18.3991L34.5542 21.4228L31.3907 25.2187L27.7056 20.8181L29.6733 18.3991Z",
    fill: "#87D2DC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1458"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2464",
    d: "M40.2574 18.787C39.4348 21.809 38.4254 29.3051 34.554 35.0666C34.554 35.0666 39.1128 33.262 42.0408 28.7524C41.1586 27.7122 40.2933 26.692 40.2933 26.692L44.8368 20.9065L40.2574 18.787Z",
    fill: "#2B286B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2465",
    d: "M28.8504 18.7869C29.6732 21.8089 30.6826 29.3051 34.5541 35.0665C34.5541 35.0665 29.9952 33.2619 27.0673 28.7524C27.9495 27.7121 28.8147 26.6919 28.8147 26.6919L24.2712 20.9065L28.8504 18.7869Z",
    fill: "#2B286B"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xC3\xA1ngulo 542",
    x: 39.8489,
    y: 33.9036,
    width: 3.07724,
    height: 1.00773,
    fill: "#2B286B"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xC3\xA1ngulo 543",
    x: 17.8057,
    y: 45.6624,
    width: 33.4971,
    height: 37.3376,
    fill: "#8D3A1E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xC3\xA1ngulo 544",
    x: 17.8057,
    y: 45.662,
    width: 33.4971,
    height: 5.63863,
    fill: "#6F2412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xC3\xA1ngulo 545",
    x: 14.71,
    y: 39.674,
    width: 39.6877,
    height: 8.66036,
    fill: "#A44124"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1460"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2466",
    d: "M10.5036 44.1719C10.3162 45.8021 8.10556 45.4654 8.28776 43.8685L9.4308 33.1456C9.61146 31.5669 11.8298 31.8454 11.6462 33.4494L10.5036 44.1719Z",
    fill: "#EE904B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2467",
    d: "M8.02536 43.3316C7.98242 44.9521 5.75089 44.8857 5.79257 43.2626L6.02155 34.4573C6.06037 32.8956 8.29395 32.8914 8.25273 34.5261L8.02536 43.3316Z",
    fill: "#EE904B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2468",
    d: "M10.8785 43.7455C10.5601 45.3995 12.7689 45.7841 13.0638 44.2475L14.7156 35.6265C15.0262 34.0056 12.826 33.5833 12.5304 35.124L10.8785 43.7455Z",
    fill: "#EE904B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2469",
    d: "M12.7788 46.948C12.4379 48.3088 14.2746 48.7962 14.6013 47.4962L16.7635 38.3306C17.1018 36.9847 15.2667 36.4863 14.9416 37.7826L12.7788 46.948Z",
    fill: "#EE904B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2470",
    d: "M12.9249 54.1292C12.5487 55.8477 12.3599 59.0775 12.3599 59.0775L5.32455 58.5585C5.42642 55.2227 5.52176 54.2469 5.07395 53.2311C2.22197 50.7909 1.99592 46.2333 0.957109 43.3166C0.445942 41.8713 0 40.7595 0 40.7595C0 40.7595 1.21036 39.4111 2.32939 41.1617C3.44898 42.9125 4.11442 47.2477 5.02244 46.3607C5.48724 45.907 5.81324 42.4986 5.81324 42.4986C5.81324 42.4986 9.54114 42.7243 11.6259 43.2951C13.7105 43.8662 14.8432 44.6153 14.8432 44.6153C14.8432 44.6153 14.9471 53.8949 12.9249 54.1292Z",
    fill: "#EE904B"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xC3\xA1ngulo 546",
    width: 5.55038,
    height: 9.79253,
    transform: "matrix(0.0973346 -0.995252 0.993181 0.116587 10.7283 62.1273)",
    fill: "#27BDCA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2471",
    d: "M14.2566 58.5606L11.8659 83.0004H0.689697L3.20949 57.2634L14.2566 58.5606Z",
    fill: "#0A282B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2472",
    d: "M13.0955 61.0337C13.0565 61.4337 12.7286 61.7233 12.3633 61.6803C11.9981 61.6375 11.7338 61.2783 11.7729 60.8782C11.812 60.4783 12.14 60.1886 12.5052 60.2314C12.8703 60.2743 13.1346 60.6336 13.0955 61.0337Z",
    fill: "#0D525C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2473",
    d: "M12.8743 63.2976C12.8352 63.6978 12.5073 63.9874 12.1424 63.9446C11.7772 63.9017 11.5126 63.5425 11.5517 63.1425C11.591 62.7425 11.9187 62.4528 12.2839 62.4956C12.649 62.5383 12.9133 62.8976 12.8743 63.2976Z",
    fill: "#0D525C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1463"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1462"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2474",
    d: "M21.1363 49.6871C21.1643 51.3301 23.395 51.2535 23.3688 49.6443L23.2755 38.8488C23.2492 37.258 21.0168 37.276 21.043 38.8924L21.1363 49.6871Z",
    fill: "#FAB67A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2475",
    d: "M23.6818 49.141C23.5669 50.7572 25.7924 50.9516 25.9086 49.333L26.5373 40.5511C26.6505 38.9937 24.4301 38.7289 24.3118 40.3592L23.6818 49.141Z",
    fill: "#FAB67A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2476",
    d: "M20.8052 49.2195C20.9609 50.9014 18.7273 51.0257 18.5836 49.4634L17.7793 40.699C17.6283 39.0508 19.8573 38.8881 20.001 40.4543L20.8052 49.2195Z",
    fill: "#FAB67A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2477",
    d: "M18.6036 52.1818C18.81 53.5747 16.9361 53.8449 16.738 52.5142L15.4793 43.1484C15.2739 41.7707 17.1471 41.4892 17.3444 42.8163L18.6036 52.1818Z",
    fill: "#FAB67A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2478",
    d: "M17.7599 59.305C17.9669 61.0574 17.8407 64.2911 17.8407 64.2911L24.8863 64.5965C25.1095 61.2675 25.1095 60.2864 25.6536 59.3286C28.7266 57.2352 29.3949 52.7299 30.7112 49.951C31.36 48.5737 31.9115 47.5201 31.9115 47.5201C31.9115 47.5201 30.839 46.0382 29.5566 47.6481C28.2728 49.2584 27.1896 53.4911 26.373 52.5034C25.9552 51.998 25.9623 48.5708 25.9623 48.5708C25.9623 48.5708 22.2337 48.3601 20.1054 48.6841C17.977 49.0087 16.7779 49.6212 16.7779 49.6212C16.7779 49.6212 15.7721 58.8361 17.7599 59.305Z",
    fill: "#FAB67A"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xC3\xA1ngulo 547",
    x: 16.6697,
    y: 60.7772,
    width: 9.7814,
    height: 5.55566,
    fill: "#27BDCA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xC3\xA1ngulo 548",
    x: 16.0046,
    y: 63.5553,
    width: 11.1115,
    height: 19.4451,
    fill: "#3C3F98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2479",
    d: "M16.9187 66.1508C16.9187 66.5532 17.2166 66.8794 17.5838 66.8794C17.9512 66.8794 18.2486 66.9556 18.2486 66.5532C18.2486 66.1508 17.9512 65.4221 17.5838 65.4221C17.2166 65.4221 16.9187 65.7484 16.9187 66.1508Z",
    fill: "#6A69AF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2480",
    d: "M16.9187 68.4283C16.9187 68.8305 17.2166 69.1566 17.5838 69.1566C17.9512 69.1566 18.2486 68.8305 18.2486 68.4283C18.2486 68.0258 17.9512 67.6995 17.5838 67.6995C17.2166 67.6995 16.9187 68.0258 16.9187 68.4283Z",
    fill: "#6A69AF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1464"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2481",
    d: "M36.3344 54.3373C36.3066 55.9803 34.076 55.9037 34.1018 54.2944L34.1956 43.4989C34.2217 41.9081 36.4542 41.926 36.4279 43.5425L36.3344 54.3373Z",
    fill: "#EE904B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2482",
    d: "M33.789 53.7911C33.9038 55.4073 31.6788 55.6016 31.5626 53.9832L30.9336 45.2011C30.8203 43.6438 33.0409 43.379 33.1589 45.0092L33.789 53.7911Z",
    fill: "#EE904B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2483",
    d: "M36.666 53.8692C36.5102 55.5512 38.7435 55.6754 38.8874 54.1132L39.6914 45.3487C39.8425 43.7006 37.6137 43.5376 37.4698 45.104L36.666 53.8692Z",
    fill: "#EE904B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2484",
    d: "M38.8672 56.832C38.6605 58.2248 40.5344 58.495 40.7327 57.1643L41.9914 47.7984C42.1965 46.4208 40.3237 46.1393 40.1262 47.4664L38.8672 56.832Z",
    fill: "#EE904B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2485",
    d: "M39.7107 63.9551C39.5038 65.7076 39.6299 68.9413 39.6299 68.9413L32.5846 69.2466C32.3611 65.9175 32.3611 64.9364 31.817 63.9787C28.744 61.8853 28.076 57.38 26.7596 54.6012C26.1106 53.2237 25.5593 52.1702 25.5593 52.1702C25.5593 52.1702 26.6315 50.6883 27.9144 52.2981C29.1979 53.9084 30.2813 58.1414 31.0978 57.1535C31.5154 56.648 31.5083 53.2208 31.5083 53.2208C31.5083 53.2208 35.2372 53.0101 37.3652 53.3343C39.4938 53.6588 40.6927 54.2714 40.6927 54.2714C40.6927 54.2714 41.6985 63.4862 39.7107 63.9551Z",
    fill: "#EE904B"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xC3\xA1ngulo 549",
    x: 31.02,
    y: 65.4274,
    width: 9.78139,
    height: 5.55566,
    fill: "#27BDCA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1465"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xC3\xA1ngulo 550",
    x: 30.5217,
    y: 67.6127,
    width: 11.1117,
    height: 15.3874,
    fill: "#DF3826"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2486",
    d: "M40.5519 70.8007C40.5519 71.2033 40.2541 71.5295 39.887 71.5295C39.5195 71.5295 39.2219 71.6055 39.2219 71.2033C39.2219 70.8007 39.5195 70.0722 39.887 70.0722C40.2541 70.0722 40.5519 70.3985 40.5519 70.8007Z",
    fill: "#6F2412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2487",
    d: "M40.5519 73.0778C40.5519 73.4801 40.2541 73.8064 39.887 73.8064C39.5195 73.8064 39.2219 73.4801 39.2219 73.0778C39.2219 72.6754 39.5195 72.3491 39.887 72.3491C40.2541 72.3491 40.5519 72.6754 40.5519 73.0778Z",
    fill: "#6F2412"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1468"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1467"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2488",
    d: "M50.2506 48.4188C50.223 50.0617 47.9922 49.9852 48.018 48.3759L48.1118 37.5804C48.138 35.9897 50.3705 36.0076 50.3441 37.624L50.2506 48.4188Z",
    fill: "#FAB67A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2489",
    d: "M47.7051 47.8727C47.8197 49.4889 45.5945 49.6832 45.4783 48.0647L44.8494 39.2827C44.7362 37.7254 46.9568 37.4605 47.0748 39.0907L47.7051 47.8727Z",
    fill: "#FAB67A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2490",
    d: "M50.582 47.9507C50.4262 49.6327 52.6596 49.757 52.8035 48.1947L53.6075 39.4302C53.7586 37.7821 51.5297 37.6192 51.3858 39.1856L50.582 47.9507Z",
    fill: "#FAB67A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2491",
    d: "M52.783 50.9134C52.5764 52.3063 54.4501 52.5766 54.6485 51.2458L55.9071 41.88C56.1124 40.5023 54.2394 40.2208 54.0419 41.5479L52.783 50.9134Z",
    fill: "#FAB67A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2492",
    d: "M53.6266 58.0367C53.4195 59.7891 53.5458 63.0228 53.5458 63.0228L46.5005 63.3282C46.2769 59.9992 46.2769 59.0181 45.7327 58.0603C42.6598 55.9668 41.9917 51.4616 40.6754 48.6828C40.0264 47.3053 39.4751 46.2518 39.4751 46.2518C39.4751 46.2518 40.5474 44.7698 41.8301 46.3796C43.1136 47.9901 44.1971 52.2229 45.0135 51.2351C45.4313 50.7296 45.4242 47.3024 45.4242 47.3024C45.4242 47.3024 49.1531 47.0916 51.2809 47.4158C53.4094 47.7404 54.6085 48.3529 54.6085 48.3529C54.6085 48.3529 55.6143 57.5679 53.6266 58.0367Z",
    fill: "#FAB67A"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xC3\xA1ngulo 551",
    x: 44.9363,
    y: 59.5089,
    width: 9.78139,
    height: 5.55559,
    fill: "#27BDCA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xC3\xA1ngulo 552",
    x: 44.2715,
    y: 62.2865,
    width: 11.1117,
    height: 20.7138,
    fill: "#2B286B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2493",
    d: "M54.4681 64.8824C54.4681 65.2849 54.1701 65.611 53.8031 65.611C53.4356 65.611 53.1379 65.2849 53.1379 64.8824C53.1379 64.4802 53.4356 64.1539 53.8031 64.1539C54.1701 64.1539 54.4681 64.4802 54.4681 64.8824Z",
    fill: "#3C3F98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2494",
    d: "M54.4683 67.159C54.4683 67.5613 54.1703 67.8875 53.8034 67.8875C53.4358 67.8875 53.1382 67.5613 53.1382 67.159C53.1382 66.7565 53.4358 66.4303 53.8034 66.4303C54.1703 66.4303 54.4683 66.7565 54.4683 67.159Z",
    fill: "#3C3F98"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1470"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1469"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2495",
    d: "M60.8443 50.654C61.0848 52.276 63.283 51.8531 63.0489 50.2643L61.5575 39.5927C61.3254 38.0223 59.118 38.3873 59.3532 39.9831L60.8443 50.654Z",
    fill: "#F39C56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2496",
    d: "M63.2934 49.7172C63.389 51.3352 65.617 51.1816 65.5223 49.5611L65.0071 40.7704C64.9171 39.2111 62.6848 39.2943 62.7793 40.9261L63.2934 49.7172Z",
    fill: "#F39C56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2497",
    d: "M60.4558 50.2423C60.8278 51.8831 58.633 52.3536 58.2884 50.8295L56.357 42.2787C55.9939 40.6709 58.1789 40.163 58.5242 41.6911L60.4558 50.2423Z",
    fill: "#F39C56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2498",
    d: "M58.6605 53.517C59.0457 54.8636 57.2256 55.4225 56.8571 54.1362L54.3975 45.061C54.016 43.7291 55.8336 43.1594 56.2007 44.442L58.6605 53.517Z",
    fill: "#F39C56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2499",
    d: "M58.7488 60.6996C59.1805 62.4021 59.4746 65.6224 59.4746 65.6224L66.4884 64.829C66.2781 61.4992 66.1508 60.5279 66.5654 59.4953C69.3361 56.945 69.4137 52.3815 70.3565 49.4261C70.8205 47.9616 71.2301 46.833 71.2301 46.833C71.2301 46.833 69.9764 45.5328 68.9152 47.326C67.8532 49.1196 67.3295 53.4779 66.3932 52.6271C65.9143 52.1919 65.4769 48.7981 65.4769 48.7981C65.4769 48.7981 61.759 49.1693 59.6943 49.8214C57.6294 50.4738 56.5217 51.2666 56.5217 51.2666C56.5217 51.2666 56.7201 60.5443 58.7488 60.6996Z",
    fill: "#F39C56"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xC3\xA1ngulo 553",
    width: 9.80118,
    height: 5.5463,
    transform: "matrix(0.987881 -0.155214 0.129792 0.991541 58.2693 61.594)",
    fill: "#27BDCA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2500",
    d: "M71.2556 83.0002H59.8944L57.562 65.1785L68.5597 63.4512L71.2556 83.0002Z",
    fill: "#DF3826"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2501",
    d: "M58.8029 67.6065C58.855 68.005 59.1922 68.2815 59.5555 68.2244C59.9191 68.1675 60.1718 67.7981 60.1195 67.3998C60.0675 67.0016 59.7306 66.725 59.3669 66.7821C59.0034 66.8392 58.7509 67.2083 58.8029 67.6065Z",
    fill: "#6F2412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2502",
    d: "M59.0976 69.8609C59.1499 70.259 59.4868 70.5357 59.8504 70.4784C60.214 70.4215 60.4663 70.0521 60.4144 69.6538C60.3621 69.2556 60.0249 68.979 59.6616 69.0361C59.298 69.093 59.0457 69.4625 59.0976 69.8609Z",
    fill: "#6F2412"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.5941877947082ceee122b29b7c74d498.svg";
export { ForwardRef as ReactComponent };